import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'En una semana ya me sentía más liviana. Dejé de picar todo el día porque ahora sé qué comer.',
    author: 'Laura M.',
    location: 'Buenos Aires'
  }, {
    quote: 'Lo mejor es que no hago dieta. Como normal y estoy bajando igual.',
    author: 'Carla R.',
    location: 'Córdoba'
  }, {
    quote: 'Antes no sabía qué cocinar. Ahora tengo todo resuelto y bajé 4 kilos sin sufrir.',
    author: 'Mariana G.',
    location: 'Rosario'
  }];
  return <section className="pt-10 pb-16 px-4 bg-brand-bgAlt" data-id="element-174">
      <div className="max-w-6xl mx-auto" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-176">
          <h2 className="text-3xl md:text-5xl font-poppins font-black text-brand-text mb-4" data-id="element-177">
            💬 TESTIMONIOS
          </h2>
          <div className="w-16 h-1 bg-brand-accent mx-auto rounded-full" data-id="element-178"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-179">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white p-8 rounded-2xl border border-green-200 border-l-4 border-l-brand-accent shadow-sm hover:shadow-md transition-shadow duration-300 flex flex-col" data-id="element-180">
              <div className="flex gap-1 mb-6" data-id="element-181">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-182" />)}
              </div>
              <p className="text-gray-700 text-lg italic mb-8 font-medium leading-relaxed flex-1" data-id="element-183">
                "{t.quote}"
              </p>
              <div className="mt-auto" data-id="element-184">
                <p className="font-poppins font-bold text-green-900" data-id="element-185">
                  {t.author}
                </p>
                <p className="text-sm text-gray-500" data-id="element-186">{t.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}